module.exports = __webpack_public_path__ + "static/media/IMG_0829_Reduced.cc3a28d6.jpg";